module.exports = __webpack_public_path__ + "static/img/场馆展示2.af6da6eb.png";